import { render, staticRenderFns } from "./PaymentAgingDetail.vue?vue&type=template&id=89c351c6"
import script from "./PaymentAgingDetail.vue?vue&type=script&lang=js"
export * from "./PaymentAgingDetail.vue?vue&type=script&lang=js"
import style0 from "./PaymentAgingDetail.vue?vue&type=style&index=0&id=89c351c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports